import { ClinicalTrialSitesPageView } from './ClinicalTrialSites.view';
import { OnSortColumnType } from '@dynamika-shared/ui/Table/Table.types';
import { usePaginationAndSort } from '@restore/helpers';
import { useMemo } from 'react';
import { useBreadcrumbs } from '@hooks/useBreadcrumbs';
import { useClinicalTrialSlice } from '@restore/clinicalTrial/clinicalTrial.slice';
import { useMakePagination } from '@restore/paginationAndSort/paginationAndSort.slice';
import { sortSites } from 'src/pages/ClinicalTrial/ClinicalTrialSites/sortSite';

export const ClinicalTrialSitesPage = () => {
  const [clinicalTrial, sites, loading] = useClinicalTrialSlice(state => [
    state.data,
    state.data?.sites ?? [],
    state.loading,
  ]);
  const { setSortBy, sortBy, currentPage, currentPageSize } =
    usePaginationAndSort('sites');

  useBreadcrumbs(
    [
      ['Clinical Trials', 'clinicalTrials'],
      [clinicalTrial?.name, 'clinicalTrialGeneralInformation'],
      ['Sites', 'clinicalTrialSites'],
    ],
    [clinicalTrial?.id]
  );

  const computedSites = useMemo(
    () => sortSites(sites, sortBy, currentPage, currentPageSize),
    [sites, currentPage, currentPageSize, sortBy]
  );

  const onSort: OnSortColumnType = (name, sortState) => {
    const newSort = sortState ? `${name},${sortState}` : undefined;
    setSortBy({ listName: 'sites', newSortBy: newSort });
  };

  const pagination = useMakePagination('sites', !!sites?.length);

  return (
    <ClinicalTrialSitesPageView
      onSort={onSort}
      sortState={sortBy}
      loading={loading}
      pagination={pagination}
      sitesData={computedSites}
      totalItems={sites?.length}
    />
  );
};
